<div class="modal-header b pb-0 px-3 pt-3">
  <!-- <p class="modal-title f-16 text-defualt" id="createnote">Note</p> -->
  <h5 class="modal-title f-16 text-defualt" id="createnote">Note <span
      *ngIf="noteforCandidate?.firstname || noteforCandidate?.lastname">for <span class="text-capitalize">
        {{noteforCandidate?.firstname}} {{noteforCandidate?.lastname}} </span> </span> </h5>
  <span type="button" class="close font-weight-normal ms-auto btn p-0 f-20" data-dismiss="modal" aria-label="Close"
    (click)="dismiss()">
    <span aria-hidden="true">&times;</span>
      </span>
</div>
<div class="modal-body px-3">
  <div class="row">
    <div class="col">
      <label for="Notes" class="f-14"> Add note <span class="text-danger">*</span></label>
      <div class="position-relative mb-3">
        <!-- <textarea data-testid="auto-app-candidate-note-textarea-1" type="text" placeholder="Enter notes for Candidate notes" [formControl]="notesControl"
          class="wc-textarea wc-form-control mb-2" rows="5" (input)="notesErrorMessage = null"></textarea>
        <span class="text-danger" *ngIf="notesControl.hasError('required') && (notesControl.dirty || notesControl.touched)">Note is required</span>
        <span class="text-danger" *ngIf="notesControl.hasError('htmlPresent')">Enter Valid data</span> -->

 <p-editor #notesElem
  (onInit)="editorOnInit($event)"
  [formControl]="notes"
  [modules]="editorModules"
  [style]="{'height':'160px', 'padding':'0', 'border':'1px solid #ccc'}"
  placeholder="Type @ to tag teammates on notes.">

  <ng-template #header>

  </ng-template>

</p-editor>

      </div>
      <span class="mb-1 text-danger" *ngIf="((notes.dirty || notes.touched) && notes.errors && notes.errors.required)">Note cannot be empty. Please provide content for the note.</span>
      <span class="mb-1 text-danger" *ngIf="((notes.dirty || notes.touched) && notes.errors && notes.errors.htmlPresent)">Note cannot contain HTML tags as input. </span>

      <span class="dropdown ats-dropBtn">
        <label class="dropdown-toggle ats-btn  text-black mb-0" role="button" appDropdownToggle aria-expanded="false">
         <i class="far fa-cog text-webbtree-green"></i> {{notePrivacy ? notePrivacy : 'Visible to everyone' }}
        </label>
        <div class="dropdown-menu asd">
        <div class="dropdown-item d-flex flex-column" >
          <label class="f-14 text-webbtree-green"><input data-testid="auto-app-candidate-note-input-1" type="radio" name="action1" id="" class="pointer" value="Visible to everyone" [(ngModel)]="shownote" (change)="changeNotePrivacy('Visible to everyone')" [checked]="returnCheckedValue('Visible to everyone')"> Visible to everyone</label>
          <span class="f-10 text-9696">All members can view</span>
        </div>
        <div  class="dropdown-divider my-0"></div>
          <div  class="dropdown-item d-flex flex-column" >
          <label class="f-14 text-webbtree-green"><input data-testid="auto-app-candidate-note-input-2" type="radio"  name="action1" id=""  class="pointer" value="Visible to selected users" [(ngModel)]="shownote" (click)="changeNotePrivacy('Visible to selected users')"  [checked]="returnCheckedValue('Visible to selected users')"> Visible to selected users</label>
          <span class="f-10 text-9696">Selected members can view</span>
          </div>
        <div class="dropdown-divider my-0"></div>
          <div class="dropdown-item d-flex flex-column">
          <label class="f-14 text-webbtree-green"><input data-testid="auto-app-candidate-note-input-3" type="radio" name="action1" id=""  class="pointer" value="Visible only to me"  [(ngModel)]="shownote" (change)="changeNotePrivacy('Visible only to me')" [checked]="returnCheckedValue('Visible only to me')"> Visible only to me</label>
          <span class="f-10 text-9696">Only you can view</span>
        </div>
        </div>
      </span>
    </div>
  </div>
  <!-- <div class="row mb-4" *ngIf="noteforCandidate && recentlyaddednotes.length > 0">
    <div class="col f-14 font-weight-600">
      Notes History
    </div>
  </div>

  <div class="notesContainer" id="noteH" *ngIf="noteforCandidate && recentlyaddednotes.length > 0">
    <div class="mb-3 mr-2" *ngFor="let notes of recentlyaddednotes">
      <div class="mb-1 d-flex justify-content-between">
        <span class="f-12 font-weight-500">
          {{notes.firstname || ""}} {{notes.lastname || ""}} - {{notes.designation}}
        </span>
         <span class="text-light-grey f-12">
          {{notes.createdon | date: 'dd MMM yyyy'}}
        </span>

        <span class='f-14 font-weight-500' [innerHtml]="notes.note"> </span>
        <span class="gray-text f-12">
          {{notes.createdon | date: 'dd MMM yyyy'}}
        </span>

      </div>
       <div class="mb-3 text-light-grey f-12" [innerHtml]="notes.note">
      </div>
    </div>
  </div> -->
  <!-- <div *ngIf="start == 2 && !noteid && totalNotesCounts > 2" class="row mt-3">
    <div (click)="pagination()" class="col-md-12">
      <label class="anchor-text pointer">
        View more ...
      </label>
    </div>
  </div> -->
</div>
<div class="modal-footer b pb-5 pt-0 px-3">
  <button data-testid="auto-app-candidate-note-button-1" class="btn-trms-small ml-auto m-0" data-dismiss="modal" type="submit" [disabled]="addNoteSpinner" (click)="saveCandidateNote()">
    <span [ngClass]="{ 'spinner-border text-light spinner-size': addNoteSpinner }" [ngStyle] = "{ 'width: 20px; height: 20px;': addNoteSpinner }">
      {{addNoteSpinner ? '' : 'Save'}}
    </span>
  </button>
</div>

<ng-template #errorModal class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-app-candidate-note-button-2" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col text-center">
          <img src="./../../../assets/images/error-vector.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <p class="text-center">ERROR</p>
          <p class="text-center">{{error_message}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-app-candidate-note-button-3" class="btn-trms-small" (click)="modalService.dismissAll()">CLOSE</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #successModal class="modal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pl-1">
          <h5 class="modal-title f-16 text-defualt" id="createnote">Note </h5>
          <button data-testid="auto-app-candidate-note-button-4" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-4">
        <div class="mb-3 mt-1 f-14 SuccessBoxed d-flex">
          <i class="fas fa-check-circle ml-2 mr-5 pt-1 f-28"></i>
          <span class="f-14 mt-3 font-weight-500"> Notes Succesfully Saved </span>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col pl-1">
          <p class="f-14 font-weight-500">Update candidate pipeline status
            <i class="fas fa-info-circle text-dis"[ngbTooltip]="pipelineplaceHolder"
              placement="right"></i>
          </p>

          <ng-template #pipelineplaceHolder>
            <p> <span class="hot-dot mr-1"></span>Hot candidate </p>
            <p class="mr-3"> All Signs Point To “Go” </p>
            <p> <span class="warm-dot mr-1"></span>Warm candidate </p>
            <p class="mr-3"> Interested, But Not Ready,
              Able Or A Good Fit
            </p>
            <p> <span class="cold-dot mr-1 "></span>Cold candidate </p>
            <p class="mr-3"> Casual Contacts and Candidates
              For Re-engagement
            </p>

          </ng-template>


          <p class="f-12">Pipeline Status <span class="text-danger">*</span></p>
          <span class="position-relative mb-1 d-flex col-6 pl-0">
            <select data-testid="auto-app-candidate-note-select-1" class="nobg wc-form-control pipeline-text-border" [(ngModel)]="talentvalue">
              <option value="null" disabled selected>Select</option>
              <option *ngFor="let status of pipeline_list" [value]="status"> {{status}} Candidate </option>
          </select>
            <span class="selectdrop-down position-absolute f-12 mt-3 mr-5 tr-x"> <i
                class="fas fa-chevron-down"></i></span>
          </span>

          <p class="text-danger f-12">
            {{talentErrorMessage}}
        </p>
        </div>

      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-app-candidate-note-button-5" class="btn-trms-small" (click)="SaveTalent();">Save</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #openVisibilityModel>
  <div class="modal-body pb-1">
    <div class="row mb-2">
      <div class="col text-center d-flex justify-content-between">
        <p class="text-black f-14 font-weight-500 mb-0">Select Users for Notes Visibility</p>
        <button data-testid="auto-app-candidate-note-button-6" type="button" class="close font-weight-normal" data-dismiss="modal" aria-label="Close"
        (click)="close()">
        <span aria-hidden="true">&times;</span>
      </button>
      </div>
    </div>
    <!-- <div class="row"> -->
      <!-- <div class="col">
        <input data-testid="auto-app-candidate-note-input-4" type="text" class="input-bottomborder" placeholder="Search team members" (input)="getJobusersAndAdmins($event.target.value)">
      </div> -->
    <!-- </div> -->
    <div class="mb-2" style="height: 200px;
    overflow-y: auto;
    overflow-x: hidden;">
    <div class="row mb-2 mr-1" *ngFor="let users of notesUsers; let i = index">
        <div class="col pr-0">
          <div class="member-card" [ngClass]="{'disabled-div': users?.disableCheckbox}">

            <div class="d-flex sm-width2">
            <div class="mr-2" [ngClass]="{'member-icon': i % 3==0,'member-blue': i % 3 == 1,'member-green': i % 3 == 2}">
              <i class="far fa-user"></i>
            </div>
            <div class="sm-width">
              <p class="text-black font-weight-500 text-capitalize">
                {{users?.firstname}} {{users?.lastname}}
              </p>
              <p class="text-484b59 text-capitalize mb-0"> {{users?.role}}
              </p>
            </div>
          </div>
          <div>
            <div class="">
              <div class="d-flex">
                <label class="wc-checkbox mb-0"  [ngClass]="{'disabled-div': users?.disableCheckbox}">
                  <input data-testid="auto-app-candidate-note-input-5" type="checkbox" id="mycheck" name="mycheck" [disabled] ="users?.disableCheckbox" [checked]="returnIsChecked(users)" (change)="selectTeamMember($event,users)">
                  <i class="fas fa-check"></i>
                </label>
              </div>
            </div>
          </div>
          </div>
        </div>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col">
      <button data-testid="auto-app-candidate-note-button-7" class="btn-trms-small ml-auto"  style="margin-right: 8px;" (click)="close()">Save</button>
    </div>
  </div>
  </div>
</ng-template>

<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
